import React, {Component} from "react";
import './../../css/table.css'
import axios from 'axios'
import {Button, Input, Select, TextArea} from "../layout/Form";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const MySwal = withReactContent(Swal);


export default class NewEntrepreneurship extends Component {
    constructor() {
        super();
        this.state = {};
    }

    render() {
        const input = this.inputHandle.bind(this);
        return (
            <div className="index">
                <form method="POST" onSubmit={this.submit.bind(this)}>
                    <Input title="دسته بندی" change={input} name="category"/>
                    <Input title="شهر" change={input} name="city"/>
                    <Input title="هزینه" change={input} name="price"/>
                    <Input title="توضیحات" change={input} name="description"/>
                    <Input title="rentalCost" change={input} name="rentalCost"/>
                    <Input title="workStaff" change={input} name="workStaff"/>
                    <Input title="inCome" change={input} name="inCome"/>

                    <div className="inputBox">
                        <label>عکس</label>
                        <input type="file" name="file" onChange={this.image.bind(this)}/>

                    </div>
                    <Button className="btn-success" type="submit" title="ثبت"/>

                </form>
            </div>
        );
    }

    inputHandle(event) {
        const input = event.target.name;
        const value = event.target.value;
        this.setState({[input]: value})

    }

    image(e) {
        this.setState({file: e.target.files[0]});
    }

    submit(event) {

        event.preventDefault();
        let formData = new FormData();
        formData.append('category', this.state.category);
        formData.append('city', this.state.city);
        formData.append('description', this.state.description);
        formData.append('price', this.state.price);
        formData.append('rentalCost', this.state.rentalCost);
        formData.append('workStaff', this.state.workStaff);
        formData.append('inCome', this.state.inCome);
        formData.append('file', this.state.file);

        axios.post('https://arianaapp.arianaapply.com/panel/new-entrepreneurship', formData).then((response) => {
            console.log(response);
            MySwal.fire({
                title: 'با موفقیت ثبت شد',
                icon: 'success'
            })
        }).catch((err) => {
            console.log(err);
            MySwal.fire({
                title: 'دوباره امتحان کنید',
                icon: 'error'
            })
        })
    }

}
